// Accesso SRH01 (Misura 2.1) per ruolo: unica fonte per sidebar (useSidebar.js) e blocco
// in Home (Misura21HomeBlock.vue), così le due non divergono.
// Il primo link di `links` è la destinazione principale del ruolo.

export function getMisura21Access(appStore) {
  const enabled = appStore.hasFeatureFlag('misura21')
  const isAdmin = appStore.hasRole('org_admin')
  // org_admin vede anche le voci riservate all'advisor (calendario e visite in campo)
  const isAdvisor = appStore.hasRole('org_advisor') || isAdmin
  // org_external: soggetto esterno (es. UCI) — dashboard di review dedicata, sola lettura
  const isExternal = appStore.hasRole('org_external')
  const isFarmer = !!appStore.isAuthenticated && !isAdmin && !isAdvisor && !isExternal

  const links = []
  if (enabled) {
    if (isAdmin) {
      links.push({ id: 'misura21-admin', label: 'Amministrazione SRH01', icon: 'ClipboardList', to: '/misura21' })
    }
    if (isExternal && !isAdmin) {
      links.push({ id: 'misura21-review', label: 'Review UCI', icon: 'ClipboardCheck', to: '/misura21/review' })
    }
    if (isAdvisor) {
      links.push({ id: 'misura21-calendar', label: 'Calendario e Report', icon: 'CalendarDays', to: '/misura21/calendar' })
      links.push({ id: 'misura21-field', label: 'Visite in Campo', icon: 'MapPin', to: '/misura21/field' })
    }
    if (isAdmin) {
      links.push({ id: 'misura21-review', label: 'Review UCI', icon: 'ClipboardCheck', to: '/misura21/review' })
    }
    if (isFarmer) {
      links.push({ id: 'misura21-my', label: 'La mia Azienda', icon: 'ClipboardCheck', to: '/misura21/my' })
      links.push({ id: 'misura21-visits', label: 'Le mie Visite SRH01', icon: 'CalendarCheck', to: '/misura21/visits' })
    }
  }

  return {
    enabled,
    isAdmin,
    isAdvisor,
    isExternal,
    isFarmer,
    // Voci "di organismo" (con intestazione SRH01 in sidebar) vs voci dell'agricoltore.
    isOrgUser: isAdmin || isAdvisor || isExternal,
    // org_external (UCI) è in sola lettura: non crea aziende in Poderi (a meno che sia anche org_admin).
    // Indipendente dal flag misura21: il ruolo org_external esiste solo per SRH01.
    canCreateFarm: !(isExternal && !isAdmin),
    links,
  }
}
